import { Descriptions } from "@arco-design/web-react";
import "./DetailCard.less";

export interface IMaterialDetialDesc {
  isEngineer?: boolean;
  resolution?: string;
  size?: string;
  type?: string;
  count?: number;
  compose_count?: number;
  create_at?: string;
  update_at?: string;
  name: string;
  creator?: string;
  imageLength?: number;
  shooting_theme?: number;
}

const toKBgetMB = (size: number | string) => {
  return (Number(size) / 1024 / 1024).toFixed(2) + "Mb";
};

const DetailCard: React.FC<IMaterialDetialDesc> = (props) => {
  const {
    isEngineer = false,
    creator,
    resolution,
    size,
    type,
    count,
    compose_count,
    create_at,
    update_at,
    name,
    imageLength,
    shooting_theme,
  } = props;

  const generateData = () => {
    const data = [];
    if (creator) data.push({ label: "创建人", value: creator });
    if (resolution) data.push({ label: "尺寸", value: resolution });
    if (size) data.push({ label: "文件大小", value: toKBgetMB(size) });
    if (imageLength) data.push({ label: "图片数量（张）", value: imageLength });
    if (type) data.push({ label: "格式", value: type });
    if (count || count === 0)
      data.push({ label: "合成成片次数 (次)", value: count });
    if (compose_count || compose_count === 0) {
      data.push({ label: "组合文案引用次数 (次)", value: compose_count });
    }
    if (create_at) data.push({ label: "创建时间", value: create_at });
    if (update_at) data.push({ label: "更新时间", value: update_at });
    if (shooting_theme)
      data.push({
        label: "拍摄类型",
        value: ["", "人设新闻体", "产品新闻体", "画面配音体", "任务新闻体"][
          shooting_theme
        ],
      });
    return data;
  };

  return (
    <div className="detail-card-wrapper">
      <div className="title">
        {isEngineer ? "工程名" : "文件名"}: <span>{name}</span>
      </div>
      <Descriptions column={1} border data={generateData()} />
    </div>
  );
};

export default DetailCard;
